import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { ImageConstraints } from 'src/app/core/models/store-templates/image-constraints';

@Component({
  selector: 'app-dynamic-image-cropper-modal',
  templateUrl: './dynamic-image-cropper-modal.component.html',
  styleUrls: ['./dynamic-image-cropper-modal.component.scss']
})
export class DynamicImageCropperModalComponent implements OnInit {

  @Input() productDialogPilot = false;
  @Input() imageChangedEvent: any;
  @Input() imageConfig:ImageConstraints = {};
  
  croppedImage: string = '';
  croppedData: Blob | null = null;
  imageFile:File;
  public isImageLoading: boolean = true;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedData = (event as any).blob;
    const mimeType = this.croppedData.type || 'image/png'; 
    const fileName = `recorte_${Date.now()}.png`; 
    this.imageFile = new File([this.croppedData], fileName, { type: mimeType });

  }

  getAspectRatioValue(): number {
    if (!this.imageConfig.aspect_ratio) {
        return 1; 
    }
    const parts = this.imageConfig.aspect_ratio.split(':');
    if (parts.length === 2) {
        const num = parseFloat(parts[0]);
        const den = parseFloat(parts[1]);
        if (den !== 0) {
            return num / den;
        }
    }
    return 1; 
}

  imageLoaded() {
    this.isImageLoading = false;
  }

  loadImageFailed() {
    this.isImageLoading = false;
  }
}
